module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_21.af5b3248.png";